import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import type { TFooterProps } from './models';

export const Footer: FC<TFooterProps> = ({
    Modal,
    children,
    className,
    layout,
    sticky,
    styles,
}) => (
    <Modal.Footer className={cn(styles.modalV2Footer, className)} layout={layout} sticky={sticky}>
        {children}
    </Modal.Footer>
);
